import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
import { Spritesheet, Texture } from "pixi.js";
export class UserProfileResourcePackage extends BundleResourcesPackage {
    public constructor() {
        super("UserProfileResourcePackage");
    }
    public get assets_views_user_profile_user_profile_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/views/user_profile/user_profile_1x.atlas.json");
    }
    public get assets_views_user_profile_frame_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["frame.png"];
    }
    public get assets_views_user_profile_underline_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["underline.png"];
    }
    public get assets_views_user_profile_progress_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["progress.png"];
    }
    public get assets_views_user_profile_progress_bg_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["progress_bg.png"];
    }
    public get assets_views_user_profile_avatar_glow_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["avatar_glow.png"];
    }
    public get assets_views_user_profile_wallet_icon_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["wallet_icon.png"];
    }
    public get assets_views_user_profile_faq_icon_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["faq_icon.png"];
    }
    public get assets_views_user_profile_leaderboard_bronze_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["leaderboard_bronze.png"];
    }
    public get assets_views_user_profile_leaderboard_silver_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["leaderboard_silver.png"];
    }
    public get assets_views_user_profile_leaderboard_golden_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["leaderboard_golden.png"];
    }
    public get assets_views_user_profile_support_icon_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["support_icon.png"];
    }
    public get assets_views_user_profile_store_icon_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["store_icon.png"];
    }
    public get assets_views_user_profile_instagram_icon_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["instagram_icon.png"];
    }
    public get assets_views_user_profile_volume_icon_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["volume_icon.png"];
    }
    public get assets_views_user_profile_switch_off_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["switch_off.png"];
    }
    public get assets_views_user_profile_switch_on_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["switch_on.png"];
    }
    public get assets_views_user_profile_left_button_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["left_button.png"];
    }
    public get assets_views_user_profile_edit_button_png(): Texture {
        return this.assets_views_user_profile_user_profile_1x_atlas_json.textures["edit_button.png"];
    }
    public get assets_views_user_profile_user_profile_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/views/user_profile/user_profile_1x.atlas.png");
    }
}

